import {
  GET_DROPDOWNS_DATA,
  FILE_COMPLAIN,
  SITE_TYPES,
  GET_SITE_INFO,
  GET_COMPLAINS_LIST,
  COMPLAIN_RAISED_TICKET,
  CLOSED_COMPAIN,
  REOPEN_COMPLAIN,
  GET_VIEW_COMPAIN,
  GET_TS_QUESTIONNAIRE,
  POST_TS_QUESTIONNAIRE,
  GET_COMPLAINS_LIST_L2,
  GET_CATEGORY_CX_CATEGORY,
  GET_CATEGORY_CX_L1,
  GET_CATEGORY_CX_L2,
  GET_CATEGORY_CX_L3,
  SAVE_ASSIGNEE_TICKET,
  CLOSE_DUPLICATE_COMPLAINT,
  ISSUE_SUBTYPE,
  FETCH_ALL_ISSUES,
  SAVE_ISSUE_REPLY,
  CENTRAL_TECH_COMPLAINS, CENTRAL_TECH_COMPLAINS_LIST, CENTRAL_TECH_LIST, CENTRAL_TECH_CHANGE,
  SAVE_CTE_COMPLAIN_REMARKS, CTE_ISSUE_LISTING
} from "./type";

const initalState = {
  siteTypes: [],
  siteInfo: [],
  formDropdowns: {},
  fileComplainRaised: null,
  fetchComplain: null,
  closeComplainRes: null,
  reopenComplainRes: null,
  raisedTicketRes: null,
  viewComplain: null,
  questionnaireList: null,
  questionnaireSaveRes: null,
  fetchComplainL2: null,
  getCategoryCXCategory: [],
  getCategoryCXL1: [],
  getCategoryCXL2: [],
  getCategoryCXL3: [],
  saveAssigneeDetails: [],
  duplicateComplainClosed: [],
  getSubIssueDropdown: [],
  getAllIssuesListing: [],
  saveRaiseIssueReply: [],
  centralTechComplainRaiseResponse: [],
  centralTechComplainRaiseListResponse: [],
  centralTechListResponse: [],
  changeCentralTechResponse: [],
  cteComplainRemarks:[],
  cteIssueList:[],
};

const fileComplainReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_TYPES:
      return {
        ...state,
        siteTypes: payload,
      };
    case GET_SITE_INFO:
      return {
        ...state,
        siteInfo: payload,
      };

    case GET_DROPDOWNS_DATA:
      return {
        ...state,
        formDropdowns: payload,
      };
    case FILE_COMPLAIN:
      return {
        ...state,
        fileComplainRaised: payload,
      };
    case GET_COMPLAINS_LIST:
      return {
        ...state,
        fetchComplain: payload,
      };
    case GET_VIEW_COMPAIN:
      return {
        ...state,
        viewComplain: payload,
      };
    case COMPLAIN_RAISED_TICKET:
      return {
        ...state,
        raisedTicketRes: payload,
      };
    case SAVE_ASSIGNEE_TICKET:
      return {
        ...state,
        saveAssigneeDetails: payload,
      };
    case CLOSED_COMPAIN:
      return {
        ...state,
        closeComplainRes: payload,
      };
    case REOPEN_COMPLAIN:
      return {
        ...state,
        reopenComplainRes: payload,
      };

    case GET_TS_QUESTIONNAIRE:
      return {
        ...state,
        questionnaireList: payload,
      };

    case POST_TS_QUESTIONNAIRE:
      return {
        ...state,
        questionnaireSaveRes: payload,
      };
    case GET_COMPLAINS_LIST_L2:
      return {
        ...state,
        fetchComplainL2: payload,
      };  
    case CLOSE_DUPLICATE_COMPLAINT:
      return {
        ...state,
        duplicateComplainClosed: payload,
      };  
    case ISSUE_SUBTYPE:
      return {
        ...state,
        getSubIssueDropdown: payload,
      }; 
    case FETCH_ALL_ISSUES:
      return {
        ...state,
        getAllIssuesListing: payload,
      };   
    case SAVE_ISSUE_REPLY:
      return {
        ...state,
        saveRaiseIssueReply: payload,
      };
    case CENTRAL_TECH_COMPLAINS:
      return {
        ...state,
        centralTechComplainRaiseResponse: payload,
      };
    case CENTRAL_TECH_COMPLAINS_LIST:
      return {
        ...state,
        centralTechComplainRaiseListResponse: payload,
      };
    case CENTRAL_TECH_LIST:
      return {
        ...state,
        centralTechListResponse: payload,
      };
    case CENTRAL_TECH_CHANGE:
      return {
        ...state,
        changeCentralTechResponse: payload,
      };
    case SAVE_CTE_COMPLAIN_REMARKS:
      return {
        ...state,
        cteComplainRemarks: payload,
      };
    case CTE_ISSUE_LISTING:
      return {
        ...state,
        cteIssueList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default fileComplainReducer;
